<template>
  <div class="lxlcard rechargeAmountView">
    <div class="mainbox">
      <!-- <div class="mainbg"> -->
      <!-- <div class="main-icon">
          <div class=""></div>
          <div class="mainfont">
            <span>智配VIP会员特权</span>
          </div>
          <div class=""></div>
        </div> -->
      <!-- 特权列表 -->
      <!-- <div class="mainlist">
          <div class="mainitem" style="margin-right:48px">
            <div class="mainicon"><img src="../../assets/images/vip-gg.png" alt=""></div>
            <div>
              <span>免广告特权</span>
            </div>
          </div>
          <div class="mainitem" style="margin-right:51px">
            <div class="mainicon"><img src="../../assets/images/vip-che.png" alt=""></div>
            <div>
              <span>看车型详情</span>
            </div>
          </div>
          <div class="mainitem" style="margin-right:48px">
            <div class="mainicon"><img src="../../assets/images/vip-wd.png" alt=""></div>
            <div>
              <span>畅查所有品牌目录</span>
            </div>
          </div>
          <div class="mainitem mainitem4">
            <div class="mainicon"><img src="../../assets/images/vip-pc.png" alt=""></div>
            <div>
              <span>电脑版使用</span>
            </div>
          </div>
        </div> -->
      <!-- </div> -->
      <div>
        <!-- 会员规格 -->
        <div class="memberbox">
          <div
            class="memberitem"
            v-for="(item, eq) in list"
            :key="eq"
            :class="item.selected ? 'adice' : ''"
            @click="onmemberclick(item)"
          >
            <div class="memberpick">
              ￥<span>{{ item.salePrice }}</span>
            </div>
            <!-- <div class="membertherr" style="text-decoration: line-through">
              {{ item.price }}
            </div> -->
            <div class="hah-right" v-if="item.selected">
              <img src="../../assets/images/pay/select_amount.png" alt="" />
            </div>
            <div class="memberone">
              VIP <span>{{ item.title }}</span>
            </div>
            <!-- 推荐标签 v-if -->
            <!-- <div class="icon" v-if="item.isRecommend">推荐</div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="hah-payTypeView">
      <div class="hah-payType">
        <div class="hah-payName">支付方式：</div>
        <div class="hah-payTab">
          <div
            :class="currentPayId == 2 ? 'hah-payWx' : ''"
            @click="check_payType(payTypeList[0], $event)"
          >
            <img src="../../assets/images/pay/icon_wxzf.png" alt="" />
            微信支付
            <img
              v-if="currentPayId == 2"
              class="hah-paySelect"
              src="../../assets/images/pay/select_wechat.png"
            />
          </div>
          <div
            :class="currentPayId == 1 ? 'hah-payZfb' : ''"
            @click="check_payType(payTypeList[1], $event)"
          >
            <img src="../../assets/images/pay/icon_zfb.png" alt="" />
            支付宝支付
            <img
              v-if="currentPayId == 1"
              class="hah-paySelect"
              src="../../assets/images/pay/select_alpay.png"
            />
          </div>
        </div>
      </div>
      <div class="hah-payCode">
        <div class="scanCode_view" v-if="is_offlineRemittanceShow != 0">
          <div v-if="currentPayId == 1 && aliPay">
            <div class="scanCode_box">
              <div class="scanCode_c">
                <img :src="qrcodeUrl + aliPay.qrcode" />
                <div class="aa-invalidCode" v-if="isInvalidShow">
                  <p>二维码已失效</p>
                  <input
                    type="submit"
                    name=""
                    value="刷新"
                    @click="initErweimaFn(0)"
                  />
                </div>
                <div class="aa-invalidCode" v-if="isInvalidMinShow"></div>
              </div>
            </div>
          </div>
          <div v-if="currentPayId == 2 && wechatPay">
            <div class="scanCode_box">
              <div class="scanCode_c">
                <img :src="qrcodeUrl + wechatPay.qrcode" />
                <div class="aa-invalidCode" v-if="isInvalidShow">
                  <p>二维码已失效</p>
                  <input
                    type="submit"
                    name=""
                    value="刷新"
                    @click="initErweimaFn(0)"
                  />
                </div>
                <div class="aa-invalidCode" v-if="isInvalidMinShow"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hah-payHint">
        完成支付即代表您已阅读并同意
        <a @click="watchAgreement">《智配Store进销存服务协议》</a>
      </div>
    </div>
    <!--  -->
    <div class="payTypeView" v-if="viewType">
      <div class="payBox">
        <!-- :class="{ is_checked: item.id==currentPayId}" -->
        <div class="rows" @click="check_payType(payTypeList[0], $event)">
          <!-- 微信支付 -->
          <div
            class="ddrows"
            :class="currentPayId == payTypeList[0].id ? 'adrows ' : ''"
          >
            <img class="payIcon" :src="payTypeList[0].payIcon" alt="" />
            <div>
              <span class="payText">{{ payTypeList[0].payText }}</span>
            </div>
          </div>
        </div>
        <div class="rows" @click="check_payType(payTypeList[1], $event)">
          <!-- 支付宝支付 -->
          <div
            class="rowsoncheck"
            :style="currentPayId == payTypeList[1].id ? 'border:none' : ''"
          >
            <div
              class="ddrows"
              :class="currentPayId == payTypeList[1].id ? 'adrows' : ''"
            >
              <img class="payIcon" :src="payTypeList[1].payIcon" alt="" />
              <div>
                <span class="payText">{{ payTypeList[1].payText }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="scanCode_view" v-if="is_offlineRemittanceShow != 0">
        <div v-if="currentPayId == 1 && aliPay">
          <div class="scanCode_box">
            <div class="scanCode_c">
              <img :src="qrcodeUrl + aliPay.qrcode" />
              <div class="aa-invalidCode" v-if="isInvalidShow">
                <p>二维码已失效</p>
                <input
                  type="submit"
                  name=""
                  value="刷新"
                  @click="initErweimaFn(0)"
                />
              </div>
              <div class="aa-invalidCode" v-if="isInvalidMinShow"></div>
            </div>
            <div class="scanCode-right">
              <div>
                支付宝扫码支付： <span style="color: #ff4552">￥</span>
                <span style="font-size: 32px; color: #ff4552">{{
                  memberad.salePrice
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="currentPayId == 2 && wechatPay">
          <div class="scanCode_box">
            <div class="scanCode_c">
              <img :src="qrcodeUrl + wechatPay.qrcode" />
              <div class="aa-invalidCode" v-if="isInvalidShow">
                <p>二维码已失效</p>
                <input
                  type="submit"
                  name=""
                  value="刷新"
                  @click="initErweimaFn(0)"
                />
              </div>
              <div class="aa-invalidCode" v-if="isInvalidMinShow"></div>
            </div>
            <div class="scanCode-right">
              <div>
                微信扫码支付： <span style="color: #ff4552">￥</span>
                <span style="font-size: 32px; color: #ff4552">{{
                  memberad.salePrice
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import server from "@/utils/server";
import no_CheckImg from "../../assets/images/no_Check.png";
import is_CheckImg from "../../assets/images/is_Check.png";
export default {
  props: {
    viewType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hostDomian: process.env.VUE_APP_API_DOMAIN, // 不同环境走不同的地址
      payTypeList: [
        {
          id: 2,
          img_checked: require("../../assets/images/no_Check.png"),
          payIcon: require("../../assets/images/wechatPays.png"),
          payText: "微信支付",
        },
        {
          id: 1,
          img_checked: require("../../assets/images/no_Check.png"),
          payIcon: require("../../assets/images/alipayPays.png"),
          payText: "支付宝支付",
        },
      ], // 支付方式列表
      currentPayId: 2, //当前点击的支付方式的id
      is_offlineRemittanceShow: 0, //  0是不显示 1是支付宝或威胁  2是否是线下汇款
      wechatPay: {},
      aliPay: {},
      qrcodeUrl: "http://www.zhipeicloud.com/Common/QRCode?data=", // 二维码的前缀地址
      queryAliPayStatus: 0,
      queryWeChatStatus: 0,
      amountData: {},
      amountCode: "", // 编码
      bankNum: "1219 2385 9210 102", // 汇款账号
      isInvalidShow: false, // 二维码是否失效
      isInvalidMinShow: false, // 二维码临时失效
      inputClearTimeid: null, //
      invalidSetTimeOutStatus: null, // 是否失效的定时器
      list: [], //会员规格列表
      memberad: {}, //选中的会员规格
    };
  },
  created() {
    this.GetCjmlVinQuerySalePrice();
    //this.getOfflineAuthCode();
  },
  methods: {
    watchAgreement() {
      window.location.href =
        "https://c1.zhipeicloud.com/agreement/saas_protocol_h5_v2.html?cf=1";
    },
    // 修改选择的会员规格
    onmemberclick(obj) {
      if (this.list.length > 0) {
        this.list.forEach((item) => {
          item.selected = false;
        });
      }
      obj.selected = true;
      this.memberad = obj;
      //console.log(this.currentPayId);
      if (this.currentPayId > 0) {
        //this.infoPurchaseClick();
        this.initErweimaFn(1);
      }
    },

    //统一入口 刷新二维码图片
    //0 输入刷新 1切换支付类型刷新
    initErweimaFn(type) {
      //清掉定时器
      this.clearPayQuey();
      this.isInvalidShow = false;

      //设置新定时器
      this.setTimeOutFn();
      this.isInvalidMinShow = true;
      // 金额改变, 1秒内二维码是不能扫的
      if (this.currentPayId == 1 || this.currentPayId == 2) {
        this.infoPurchaseClick();
      }
    },
    // 获取二维码支付
    async infoPurchaseClick() {
      // 支付方式 2支付宝二维码 5微信二维码
      let request_data = {
        payType: this.currentPayId,
        set: this.memberad.set,
      };
      await server
        .myAxios("/api/Deposit/GetDepositRechargePaymentQRCode", request_data)
        .then((res) => {
          console.log(res);
          console.log(res.ErrorCode);
          if (res.QRCode.key > 0) {
            this.isInvalidMinShow = false;
            this.isInvalidShow = false;
          }
          //this.currentPayId=2;
          this.wechatPay = res.QRCode;
          this.aliPay = res.QRCode;
          this.queryPayStatus();
        });
    },
    GetCjmlVinQuerySalePrice() {
      let _this = this;
      server.myAxios("/api/Deposit/GetCjmlVinQuerySalePrice").then((res) => {
        _this.list = res.salePrice;
        //  memberad
        _this.list.forEach((item) => {
          if (item.selected) {
            this.memberad = item;
            this.is_offlineRemittanceShow = 1;
            //this.infoPurchaseClick();
            this.initErweimaFn(1);
          }
        });
      });
    },
    // 定时器来使二维码失效
    setTimeOutFn() {
      clearTimeout(this.invalidSetTimeOutStatus);
      this.invalidSetTimeOutStatus = setTimeout(() => {
        this.isInvalidShow = true;
      }, 180000);
    },
    // 查询支付状态
    async queryPayStatus() {
      // console.log("开启轮训",this.currentPayId );
      let _this = this;
      let request_data = {
        key: _this.aliPay.key,
      };
      if (_this.currentPayId == 1) {
        _this.queryAliPayStatus = setInterval(async () => {
          await server
            .myAxios(
              "/api/Deposit/GetDepositRechargePaymentStatus",
              request_data
            )
            .then((res) => {
              if (res.status == "success") {
                _this.handlePayStatus(res);
              }
            });
        }, 1000);
      }
      if (_this.currentPayId == 2) {
        _this.queryWeChatStatus = setInterval(async () => {
          await server
            .myAxios(
              "/api/Deposit/GetDepositRechargePaymentStatus",
              request_data
            )
            .then((res) => {
              if (res.status == "success") {
                _this.handlePayStatus(res);
              }
            });
        }, 1000);
      }
    },
    // 清除支付状态
    clearPayQuey() {
      //   console.log("关闭轮训",this.queryAliPayStatus );
      //   console.log("关闭轮训",this.queryWeChatStatus );
      if (this.queryAliPayStatus != 0) {
        clearInterval(this.queryAliPayStatus);
        this.queryAliPayStatus = 0;
      }
      if (this.queryWeChatStatus != 0) {
        clearInterval(this.queryWeChatStatus);
        this.queryWeChatStatus = 0;
      }
    },
    // 支付后的状态
    handlePayStatus(res) {
      this.clearPayQuey();
      var result = res;
      if (result.status == "failed") {
        // this.$message({
        //   message: result.reason,
        //   type: "warning"
        // });
        this.wechatPay = "";
        this.aliPay = "";
        this.initErweimaFn();
      } else if (result.status == "success") {
        this.wechatPay = "";
        this.aliPay = "";
        this.$emit("PaySuccess");
      } else {
      }
    },
    // 选择支付方式
    check_payType(item, $event) {
      // 清除之前二维码的状态
      console.log(item);
      this.wechatPay = "";
      this.aliPay = "";
      this.payTypeList.forEach((element) => {
        element.img_checked = no_CheckImg;
      });
      item.img_checked = is_CheckImg;
      this.is_offlineRemittanceShow = item.id == 3 ? 2 : 1;
      if (item.id != 3) {
        this.currentPayId = item.id;
        this.initErweimaFn(1);
      } else {
        this.currentPayId = "";
      }
    },
  },
  beforeDestroy() {
    this.clearPayQuey();
  },
  components: {},
};
</script>
<style scpoed lang="less">
.rechargeAmountView {
  .mainbox {
    width: 100%;
    padding: 10px;
    .mainbg {
      width: 590px;
      height: 108px;
      // opacity: 0.08;
      background: #fffcf3;
      border-radius: 4px;
      // z-index: -1;
      .main-icon {
        width: 100%;
        min-height: 60px;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        z-index: 99;
        div {
          border-top: 1px solid rgba(244, 179, 30, 0.4);
          width: 162px;
          height: 1px;
        }
        .mainfont {
          border: none;
          height: auto;
          max-height: 50px;
          margin: 0 30px;
          width: 150px;
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: center;
          color: #282828;
          line-height: 30px;
          letter-spacing: 3px;
        }
      }
      .mainlist {
        display: flex;
        flex-wrap: wrap;
        padding: 0 5% 30px;
        .mainitem {
          display: flex;
          font-size: 12px;
          color: #282828;
          .mainicon {
            width: 20px;
            height: 20px;
            margin-right: 6px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .memberbox {
      width: 100%;
      min-height: 80px;
      display: flex;
      justify-content: space-between;
      padding: 15px 0;
      .memberitem {
        cursor: pointer;
        min-width: 160px;
        height: 120px;
        background: #ffffff;
        width: 30%;
        border: 1px solid #dcdcdc;
        border-radius: 4px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        position: relative;
        div {
          width: 100%;
          text-align: center;
          font-size: 14px;
          color: #333333;
        }
        .hah-right {
          width: 30px;
          height: 24px;
          position: absolute;
          top: 0;
          right: 0;
        }
        .membertherr {
          font-size: 12px;
          color: #bcbcbc;
        }
        .memberpick {
          color: #ff4552;
          font-size: 16px;
          span {
            font-weight: 600;
            font-size: 30px;
            font-family: HelveticaInseratLTStd, HelveticaInseratLTStd-Roman;
            font-weight: Roman;
          }
        }
        .memberone {
          width: 126px;
          border-top: 1px solid #d8d8d8;
          padding: 6px;
        }

        .icon {
          position: absolute;
          top: -8px;
          left: -1px;
          width: 54px;
          height: 20px;
          background: linear-gradient(90deg, #ff7187, #ff0000 100%);
          border-radius: 0px 6px 0px 0px;
          font-size: 12px;
          text-align: center;
          line-height: 20px;
          color: #fff;
        }
      }
      .adice {
        border-color: #f0265e;
      }
    }
  }
  .hah-payTypeView {
    width: 350px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    .hah-payType {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .hah-payName {
        width: 70px;
        font-size: 14px;
        color: #939393;
      }
      .hah-payTab {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        div {
          width: 126px;
          height: 32px;
          background: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #d8d8d8;
          border-radius: 3px;
          position: relative;
          cursor: pointer;
          img {
            width: 18px;
            height: 18px;
            margin-right: 8px;
          }
          .hah-paySelect {
            position: absolute;
            top: 0;
            right: 0;
            width: 20px;
            height: 16px;
            margin-right: 0;
          }
        }
        .hah-payWx {
          border: 1px solid #0dc562;
        }
        .hah-payZfb {
          border: 1px solid #1677ff;
        }
      }
    }
    .hah-payCode {
      width: 100%;
      height: 168px;
      margin: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      .scanCode_view {
        flex: 1;
        span {
          font-size: 14px;
          line-height: 20px;
          color: #5b5b5b;
          margin: 12px 0;
          display: inline-block;
        }
        .scanCode_box {
          width: 100%;
          height: 138px;
          // box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 11px 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          .bg {
            position: absolute;
            top: 0;
            left: -2px;
            width: 3px;
            height: 52px;

            z-index: 999;
          }
          .scanCode_c {
            width: 150px;
            height: 150px;
            position: relative;
          }
          img {
            width: 150px;
            height: 150px;
          }
        }
        .remittanceExamples {
          box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 11px 0px;
          padding: 30px 28px;
          font-size: 14px;
          width: 860px;
          border: 1px solid rgba(215, 216, 217, 1);
          .remittanceCode {
            padding-bottom: 16px;
            display: flex;
            width: max-content;
            border-bottom: 1px solid #d7d8d9;
          }
          .remittance_right {
            margin-top: -5px;
            .top {
              color: #e74c3c;
              font-size: 14px;
              line-height: 32px;
            }
            .bottom {
              line-height: 32px;
              display: flex;
            }
          }
          .openAccountName {
            display: flex;
            line-height: 32px;
            margin: 16px 0;
          }
          .openAccountBank {
            display: flex;
            .top {
              margin-top: -12px;
              img {
                border: 1px solid rgba(215, 216, 217, 1);
                margin-right: 6px;
              }
            }
            .bottom {
              display: flex;
              align-items: center;
              .accountLabel {
                color: #999;
              }
            }
          }
        }
        .com_label {
          font-size: 16px;
        }
        .left_code {
          color: #181818;
          font-size: 16px;
          height: 32px;
          line-height: 32px;
          background-color: rgb(249, 249, 249);
          // width: min-content;
          padding: 2px 15px;
        }
        .copyBtn {
          border: 1px solid #e74c3c;
          padding: 0px 16px;
          border-radius: 4px;
          cursor: pointer;
          margin-left: 16px;
          width: max-content;
          height: 34px;
          display: flex;
          align-items: center;
          color: #e74c3c;
        }
      }
    }
    .hah-payHint {
      font-size: 12px;
      color: #333333;
      a {
        color: #377de8;
        cursor: pointer;
      }
    }
  }

  .payTypeView {
    display: flex;
    // background-color: #f9f9f9;
    width: 590px;
    height: 139px;
    background: #ffffff;
    border: 1px solid #dcdcdc;
    border-radius: 4px;
    .payBox {
      width: 138px;
      .rows {
        background: #f8f8f8;
        cursor: pointer;
        display: flex;
        width: 138px;
        min-height: 50px;
        box-sizing: border-box;
        align-items: center;
        .ddrows {
          padding: 15px 0 15px 20px;
          display: flex;
        }
        .adrows {
          width: 100%;
          background-color: #fff;
        }
      }
      .rowsoncheck {
        width: 138px;
        height: 87px;
        background: #f8f8f8;
        border: 1px solid #dcdcdc;
      }
      .rows.is_checked {
        border: 2px solid rgba(231, 76, 60, 1);
      }
      .img_checked {
        img {
          width: 16px;
          height: 16px;
        }
        margin-right: 12px;
      }
      .payIcon {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
      .payText {
        width: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #181818;
      }
    }
    .scanCode_view {
      flex: 1;
      span {
        font-size: 14px;
        line-height: 20px;
        color: #5b5b5b;
        margin: 12px 0;
        display: inline-block;
      }
      .scanCode_box {
        width: 100%;
        height: 138px;
        // box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 11px 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        .bg {
          position: absolute;
          top: 0;
          left: -2px;
          width: 3px;
          height: 52px;

          z-index: 999;
        }
        .scanCode_c {
          width: 108px;
          height: 108px;
          margin-left: 55px;
          position: relative;
        }
        .scanCode-right {
          flex: 1;
          height: 138px;
          padding-top: 55px;
          div {
            width: 100%;
            height: 50px;
            padding-left: 30px;
            line-height: 50px;
          }
        }
        img {
          width: 108px;
          height: 108px;
        }
      }
      .remittanceExamples {
        box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 11px 0px;
        padding: 30px 28px;
        font-size: 14px;
        width: 860px;
        border: 1px solid rgba(215, 216, 217, 1);
        .remittanceCode {
          padding-bottom: 16px;
          display: flex;
          width: max-content;
          border-bottom: 1px solid #d7d8d9;
        }
        .remittance_right {
          margin-top: -5px;
          .top {
            color: #e74c3c;
            font-size: 14px;
            line-height: 32px;
          }
          .bottom {
            line-height: 32px;
            display: flex;
          }
        }
        .openAccountName {
          display: flex;
          line-height: 32px;
          margin: 16px 0;
        }
        .openAccountBank {
          display: flex;
          .top {
            margin-top: -12px;
            img {
              border: 1px solid rgba(215, 216, 217, 1);
              margin-right: 6px;
            }
          }
          .bottom {
            display: flex;
            align-items: center;
            .accountLabel {
              color: #999;
            }
          }
        }
      }
      .com_label {
        font-size: 16px;
      }
      .left_code {
        color: #181818;
        font-size: 16px;
        height: 32px;
        line-height: 32px;
        background-color: rgb(249, 249, 249);
        // width: min-content;
        padding: 2px 15px;
      }
      .copyBtn {
        border: 1px solid #e74c3c;
        padding: 0px 16px;
        border-radius: 4px;
        cursor: pointer;
        margin-left: 16px;
        width: max-content;
        height: 34px;
        display: flex;
        align-items: center;
        color: #e74c3c;
      }
    }
  }

  .wrapper_box {
    height: 300px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .wrapper-view {
      display: flex;
      flex-direction: column;

      justify-content: center;
      align-items: center;
      img {
        width: 50px;
        height: 50px;
        margin-bottom: 20px;
      }
      p {
        color: #666;
        font-size: 24px;
        margin-bottom: 15px;
      }
      .spans {
        color: #666;
        margin-bottom: 12px;
      }
      .el-button {
        height: 30px;
        border-radius: 5px;
      }
    }
  }

  .el-radio__input {
    white-space: nowrap;
    cursor: pointer;
    outline: none;
    display: inline-block;
    line-height: 1;
    position: relative;
    vertical-align: middle;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: #409eff;
    background: #409eff;
  }

  .el-radio__inner {
    border: 1px solid #dcdfe6;
    border-radius: 100%;
    width: 14px;
    height: 14px;
    background-color: #fff;
    position: relative;
    cursor: pointer;
    display: inline-block;
    box-sizing: border-box;
  }

  .el-radio__inner:after {
    width: 4px;
    height: 4px;
    border-radius: 100%;
    background-color: #fff;
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(0);
    transition: transform 0.15s ease-in;
  }
}

.hbb-saoSuccess {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
  background: rgba(255, 255, 255, 0.96);
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  font-size: 22px;
  color: #282828;
}
.aa-invalidCode {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.78);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.aa-invalidCode > p {
  width: 100%;
  height: 36px;
  font-size: 18px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  margin-top: 7px;
  float: left;
  clear: left;
}

.aa-invalidCode > input {
  width: 94px;
  height: 36px;
  background: #d53533;
  font-size: 16px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  margin: 12px 49px 0;
  float: left;
  clear: left;
  border: 0;
}
</style>

